import { render, staticRenderFns } from "./TranslationsTable.vue?vue&type=template&id=453799c5"
import script from "./TranslationsTable.js?vue&type=script&lang=js&external"
export * from "./TranslationsTable.js?vue&type=script&lang=js&external"
import style0 from "./TranslationsTable.vue?vue&type=style&index=0&id=453799c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports